import { connect } from 'react-redux'
import moment from 'moment'
import get from 'lodash/get'

import ServicingCard from '../../components/servicings/servicing-card'

import { removeMergedServices } from '../../actions/servicings'

import at from 'lodash/at'

const mapStateToProps = (state, props) => {
  const servicing = state.servicings[props.id]
  const services = at(state.services, servicing.services || []).map(s => ({
    ...s,
    completedAt: servicing.servicesServicings[s.id].completedAt ? 
      moment(servicing.servicesServicings[s.id].completedAt) : null
  }))
  const serviceNames = services.map(service => service.name)
  const urlPath = props.urlPath
  const { showInputted } = get(state.workOrders, props.workOrderId, {})
  const inputtedBy = get(state.users, servicing.createdBy, {})

  return {
    ...servicing,
    area: state.areas[servicing.area] || {},
    key: servicing.id,
    serviceNames,
    services,
    assignee: state.users[servicing.assignee] || {},
    claimer: servicing.claimedBy || {},
    urlPath,
    showInputted,
    inputtedBy,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    removeMergedServicesLabels() {
      dispatch(removeMergedServices(props.id))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicingCard)



// WEBPACK FOOTER //
// ./src/containers/servicings/servicing-card-container.js